// extracted by mini-css-extract-plugin
export default {"subtitle":"DocumentUploadSubtitle_subtitle__OtZRF","fixed":"DocumentUploadSubtitle_fixed__HEY7f","name":"DocumentUploadSubtitle_name__pv6Gu"};